import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class IdempotencyService {

  private readonly STORAGE_KEY = 'charger_idempotency_key';

  private currentKey: string | null = null;
  private activeRequests = 0;

  public acquireKey(): string {
    this.activeRequests++;

    if (this.currentKey) {
      return this.currentKey;
    }

    let key = sessionStorage.getItem(this.STORAGE_KEY);

    if (!key) {
      key = uuidv4();
      sessionStorage.setItem(this.STORAGE_KEY, key);
    }

    this.currentKey = key;

    return key;
  }

  public completeRequest(): void {
    this.activeRequests--;

    if (this.activeRequests < 0) {
      this.activeRequests = 0;
    }

    if (this.activeRequests <= 0) {
      this.currentKey = null;
      sessionStorage.removeItem(this.STORAGE_KEY);
    }
  }
}